module.exports = "/static-assets/_next/static/images/hero-038c9dd3e954b2320f7f471f20261b44.webp";